import gql from 'graphql-tag';

const GET_CAMPAIGN_ORDERS_DRAFT = gql`
  query campaignOrdersDraft(
    $where: CampaignOrderWhereInput!
    $first: Int
    $skip: Int
    $after: String
    $before: String
    $orderBy: CampaignOrderOrderByInput
    $last: Int
  ) {
    campaignOrdersConnection: campaignOrdersConnection(
      where: $where
      orderBy: $orderBy
      skip: $skip
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          startDate
          endDate
          budget
          cpm
          createdAt
          notes
          createdBy {
            id
            name
            email
          }
          advertiser {
            id
            CPAcronym
            level
            name
            parentOrg {
              id
              level
              name
              CPAcronym
              createdAt
            }
          }
          IONumber
          productCode
          attributionTargets {
            id
          }
          transactionsConfig {
            appId
            gtmAccess
            tag
          }
          tags
          awarenessCampaign
          changeLog(first: 50) {
            id
            changedBy {
              id
              name
              email
            }
            description
            createdAt
          }
          histories(first: 50) {
            id
            action
            author {
              id
              name
              email
            }
            property
            createdAt
          }
          auditHistory(first: 50) {
            id
            user
            createdAt
          }
          geoTargets(first: 10) {
            id
          }
          campaigns(first: 10) {
            id
            name
            hasMediaPlanStrategy
            lineItems(first: 20) {
              id
              name
              budgetTotal
              startDate
              endDate
              targetingLocations(first: 5) {
                id
              }
              targetingRegions(first: 5) {
                id
              }
              targetingCountries(first: 5) {
                id
              }
              firstPartyDataAudiences(first: 5) {
                id
                name
                activated
              }
              audienceType
              adGroup {
                id
                adGroupCreatives(first: 10) {
                  id
                  name
                }
              }
            }
          }
        }
      }
      aggregate {
        count
      }
    }

    full: campaignOrdersConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default GET_CAMPAIGN_ORDERS_DRAFT;
